import 'rise-navigation';

import ENV from 'rise-ui/config/environment.js';
import { set } from 'rise-ui/utils/object.js';
import transitionHasRoute from 'rise-ui/utils/transition-has-route.js';

const { breadcrumbs, menuItems } = riseNavigation;

/**
 * Configure riseNavigation for use within RISE UI.
 * Primary/common configuration should be made from `rise-navigation.js`, which
 * may also be used by external applications to replicate RISE UI menus.
 * @See exports/rise-navigation.js
 * @See public/assets/exports/rise-navigation.js
 */

const breadcrumbsMeta = [
  { key: 'usbr', main: true },
  { key: 'rise', main: true, route: 'index' },
  { key: 'visualizations',   route: 'visualizations' },
];

const menuItemsMeta = [
  { key: 'index',          route: 'index' },
  { key: 'catalog',        route: 'catalog' },
  { key: 'time-series',    route: 'time-series' },
  { key: 'rise-api',       route: 'rise-api' },
  { key: 'visualizations', route: 'visualizations' },
  { key: 'contact',        route: 'contact' },
  { key: 'help',           route: 'help' },
  { key: 'about',          route: 'about' },
];

// See menu initializer for riseUrl and additional settings requiring service access
riseNavigation.setUrlTokens({ mapUrl: ENV.APP.API.MAP.HOST });

// Attach meta data to appropriate breadcrumb/menu items
[
  [ breadcrumbs, breadcrumbsMeta ],
  [ menuItems, menuItemsMeta ],
].forEach(([ items, meta ]) => items.forEach(item =>
  Object.assign(item, meta.find(s => s.key === item.key) || {})
));

export function initialize(appInstance) {
  const router = appInstance.lookup('service:router');
  const routing = appInstance.lookup('service:routing');
  // Assign service dependent variables
  riseNavigation.setUrlTokens({ riseUrl: routing.baseURL }); // Based on current URL
  // Define getter for _url for each breadcrumb/menu item's interpolated url
  [ breadcrumbs, menuItems ].forEach(items => {
    items.forEach(item => {
      if (!('_url' in item)) {
        Object.defineProperty(item, '_url', {
          get() { return riseNavigation.replaceUrlTokens(item.url); },
        });
      }
    });
  });
  // Set isActive for each menuItem when route is active
  router.on('routeDidChange', transition => {
    menuItems.forEach(menuItem => {
      const { route } = menuItem;
      if (route) {
        set(menuItem, 'isActive', !!transitionHasRoute(transition, route));
      }
    });
  });
}

export default {
  initialize,
};
